<div class="sidebar-candidate-reference-requests"><app-loading [isLoading]="isLoading"><app-table [cols]="cols" [rows]="rows" [onButtonClick]="onButtonClick"></app-table></app-loading></div>
